import { Text, View } from 'react-native'
import { colors } from '@/src/theme'
import { body2, label1 } from '@/src/theme/typography'

export function PurchaseErrorNotice({
  title,
  message,
}: {
  title: string
  message: string
}) {
  return (
    <View
      className="mb-4 rounded-2xl px-4 py-3"
      style={{
        backgroundColor: '#FCEBEC',
        borderWidth: 1,
        borderColor: '#F4C7CB',
      }}
    >
      <Text className="mb-1" style={[label1, { color: colors.destructive }]}>
        {title}
      </Text>
      <Text style={[body2, { color: colors.inkSecondary }]}>{message}</Text>
    </View>
  )
}
